
import { createStore, applyMiddleware } from 'redux';

import { persistStore, persistReducer } from 'redux-persist';

import createSagaMiddleware from 'redux-saga';

import rootReducer from './reducers';

import { rootSaga } from './sagas';

import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'sg-v2',
  storage,
  whitelist: [
    'cartpage',
    'auth',
    'recentlyViewedProducts',
    'wishlistpage',
    'languages',
  ],
};

// One-time cleanup of the old Redux Persist storage.
// The old `persist:root` contained large/stale API page data.
try {
  const oldPersistedState = localStorage.getItem('persist:root');

  if (oldPersistedState !== null) {
    localStorage.removeItem('persist:root');
  }
} catch (error) {
  console.warn('Unable to clean old Redux Persist storage:', error);
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  persistedReducer,
  applyMiddleware(sagaMiddleware)
);

sagaMiddleware.run(rootSaga);

// Route sagas are injected once, before their page component is rendered.
// Keeping the registry on the store prevents duplicate watchers when users
// navigate away from a route and return to it.
const injectedSagas = new Map();

store.injectSaga = (key, saga) => {
  if (injectedSagas.has(key)) {
    return injectedSagas.get(key);
  }

  const task = sagaMiddleware.run(saga);
  injectedSagas.set(key, task);
  return task;
};

const persistor = persistStore(store);

export { store, persistor };

